<template>
  <div
    class="flex justify-between items-center h-14 min-h-[3.5rem] px-4 py-2 bg-white dark:bg-slate-900 border-b border-slate-50 dark:border-slate-800/50"
  >
    <div class="flex w-full justify-between items-center gap-4">
      <!-- <div class="back-icon" @click="handleBackClick">
        <fluent-icon
          v-tooltip="'Back'"
          icon="back"
          :viewBox="'0 0 52 52'"
          size="14"
          class="mt-0.5 back-contact cursor-pointer"
        />
      </div> -->
      <h1
        class="text-2xl mb-0 flex items-center text-slate-900 dark:text-slate-100 text-nowrap"
      >
        <!-- <woot-sidemenu-icon v-if="showSidemenuIcon" />  -->
      <fluent-icon
        v-if="icon"
        :icon="icon"
        :class="iconClass"
        class="mr-2 ml-4 rtl:ml-2 rtl:mr-4"
        :viewBox="getViewBox(icon)"
      />
      <slot />
        <span class="text-slate-900 dark:text-slate-100">{{
          headerTitle
        }}</span>
      </h1>
      <div class="w-full z-[2] flex justify-center">
        <div v-if="isSettingsStatusRoute" class="">
        <CustomDropdown 
          :boards="boards"
          placeholder="Board"
          :open="openDropdown === 'board'"
          @input="handleDropdownBoard"
          @toggle="toggleDropdown('board')"
        />
        <!-- <add-more-board :show="showMoreBoard" @close="hideMoreboard" /> -->
      </div>
      </div>
    </div>
    <router-link
      v-if="showNewButton && isAdmin"
      :to="buttonRoute"
      class="button success button--fixed-top"
    >
      <fluent-icon icon="add-circle" />
      <span class="button__content">
        {{ buttonText }}
      </span>
    </router-link>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import BackButton from '../../../components/widgets/BackButton';
import adminMixin from '../../../mixins/isAdmin';
import CustomDropdown from './pipelines/CustomDropdown.vue';
import AddMoreBoard from './pipelines/AddMoreBoards.vue';
export default {
  components: {
    BackButton,
    CustomDropdown,
    AddMoreBoard
  },
  data(){
    return{
    openDropdown :null,
    showMoreBoard: false,
    selectedBoard: '',
    selectedState: '',
    searchQuery: '',
    currentAssignee: null,
    selectedSource: '',
    filterMonths: '',
    scheduledAtFrom: '',
    scheduledAtTo: '',
  }
  },
  mixins: [adminMixin],
  props: {
    headerTitle: {
      default: '',
      type: String,
    },
    buttonRoute: {
      default: '',
      type: String,
    },
    buttonText: {
      default: '',
      type: String,
    },
    icon: {
      default: '',
      type: String,
    },
    showBackButton: { type: Boolean, default: false },
    showNewButton: { type: Boolean, default: false },
    backUrl: {
      type: [String, Object],
      default: '',
    },
    backButtonLabel: {
      type: String,
      default: '',
    },
    showSidemenuIcon: {
      type: Boolean,
      default: true,
    },
    pipelineContact:{
      type: Boolean,
      default: false,
    }
  },
  updated() {
    if (this.headerTitle) {
      document.title = `${this.headerTitle} | Kivo`;
    }
  },
  watch: {
  headerTitle(newTitle) {
    document.title = `${newTitle} | Kivo`;
  }
},
mounted() {
  if (this.headerTitle) {
    document.title = `${this.headerTitle} | Kivo`;
  }
},
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
    }),
    iconClass() {
      return `icon ${this.icon} header--icon`;
    },
    boards() {
      const apiBoards = this.$store.getters['pipelines/getAllBoards'] || [];
      console.log("apiBoards" , apiBoards)
      // Filter out any board named "Default Board" with an id
      const filteredBoards = apiBoards.filter(
        board => !(board.name === 'Default Board' && board.id)
      );

      // Add your intended default board manually (id: '')
      return [{ id: '', name: 'Default Board' }, ...filteredBoards];
    },
    isSettingsStatusRoute() {
    return this.$route.path.endsWith('/settings/status');
  }

  },
  methods: {
    handleBackClick() {
      console.log('account id :- ' + this.$route.params.accountId);
      // return `/app/accounts/${this.$route.params.accountId}/reports/overview`;
      this.$router.push({ name: 'settings_account_reports' });
    },
    getViewBox(icon){
        if(icon === 'arrow-trending-lines'){
          return '2 0 24 30'
        }
        return '0 0 24 24'
    },
    BackContact(){
      this.$router.push({ name: 'pipeline' });
    },
    toggleDropdown(dropdownName) {
      bus.$emit('toggle-pipeline-dropdown');
      this.showAssignee = false;
      this.openDropdown =
        this.openDropdown === dropdownName ? null : dropdownName;
    },
    handleDropdownBoard(selectedId) {
      this.selectedBoard = selectedId;
      console.log('Selected Boards:', this.selectedBoard);

      bus.$emit('boardId',this.selectedBoard)

      if (this.selectedBoard === 'add-more-board') {
        this.showMoreBoard = true;
      } else if (this.selectedBoard === '') {
        // "All" selected — navigate to default pipeline route

        this.callApiboard(this.selectedBoard);
      } else if (this.selectedBoard !== 'add-more') {
        this.callApiboard(this.selectedBoard);
      }
    },
    callApiboard(selectedBoard) {
      console.log(`Making API call with state: ${selectedBoard}`);
      let data = {
        key: 'state_id',
        value: this.selectedState, // The state filter
        key1: 'name',
        value1: this.searchQuery, // The name filter
        key4: 'board_id',
        value4: this.selectedBoard,
        key5: 'assignee_id',
        value5: this.currentAssignee,
        key6: 'source_id',
        value6: this.selectedSource,
      };

      // Normalize filterMonths value (e.g., replacing spaces with underscores)
      const normalizedFilter = this.filterMonths?.replace(/\s+/g, '_');

      if (normalizedFilter) {
        switch (normalizedFilter) {
          case 'all':
            data.key2 = 'all';
            data.value2 = this.filterMonths;
            break;
          case 'last_week':
            data.key2 = 'last_week';
            data.value2 = this.filterMonths;
            break;
          case 'last_month':
            data.key2 = 'last_month';
            data.value2 = this.filterMonths;
            break;
          case 'last_six_months':
            data.key2 = 'last_six_months';
            data.value2 = this.filterMonths;
            break;
          default:
            console.warn('Unknown filterMonths value:', this.filterMonths);
            break;
        }
      } else {
        data.key2 = 'start_date';
        data.value2 = this.scheduledAtFrom; // The start date filter
        data.key3 = 'end_date';
        data.value3 = this.scheduledAtTo; // The end date filter
      }
      this.$store.dispatch('pipelines/FilterContact', data);
    },
    hideMoreboard() {
      this.showMoreBoard = false;
    },
  }
};
</script>